import { VALIDATION_MESSAGES } from '../constants/formConstants.js'

export const validateMinimumLength = (value) => (value.trim().length >= 2 ? null : VALIDATION_MESSAGES.MIN_LENGTH_ERROR)

/**
 * Valida el número de teléfono principal:
 * - Exactamente 10 dígitos
 * - No debe comenzar con 0 ni con 15
 * @param {string} value - Valor crudo del teléfono (puede incluir formato)
 * @returns {string|null} Mensaje de error o null si es válido
 */
export const validatePhoneNumber = (value) => {
  const digits = (value || '').replace(/\D/g, '')

  if (digits.length === 0) {
    return VALIDATION_MESSAGES.TELEFONO_INVALID
  }

  // Normaliza el prefijo internacional argentino (+54) si está presente,
  // ya que el Design System puede formatear el valor con código de país
  const normalized = digits.startsWith('54') && digits.length > 10 ? digits.slice(2) : digits

  if (normalized.length !== 10) {
    return VALIDATION_MESSAGES.TELEFONO_INVALID
  }

  if (normalized.startsWith('0') || normalized.startsWith('15')) {
    return VALIDATION_MESSAGES.TELEFONO_INVALID
  }

  return null
}

/**
 * Valida que el tipo de teléfono principal esté seleccionado
 * @param {string} value - Tipo de teléfono seleccionado
 * @returns {string|null} Mensaje de error o null si es válido
 */
export const validateTipoTelefono = (value) =>
  (value || '').trim() === '' ? VALIDATION_MESSAGES.TIPO_TELEFONO_REQUIRED : null

export const validateField = (field, value) => {
  switch (field) {
    case 'apellido':
      return (value || '').trim() === '' ? VALIDATION_MESSAGES.APELLIDO_REQUIRED : validateMinimumLength(value)
    case 'nombre':
      return (value || '').trim() === '' ? VALIDATION_MESSAGES.NOMBRE_REQUIRED : validateMinimumLength(value)
    case 'tipoTelefonoPrincipal':
      return validateTipoTelefono(value)
    case 'numeroTelefonoPrincipal':
      return validatePhoneNumber(value)
    case 'numeroTelefonoAlternativo':
      // Campo opcional: vacío no genera error de formato
      return (value || '').trim() === '' ? null : validatePhoneNumber(value)
    default:
      return null
  }
}

/**
 * Validación conjunta del teléfono alternativo (tipo + número).
 * Ambos campos son opcionales, pero si uno está cargado el otro pasa a ser
 * obligatorio. Devuelve el error correspondiente para cada campo.
 * @param {string} tipoAlt - Tipo de teléfono alternativo seleccionado
 * @param {string} numAlt - Número de teléfono alternativo ingresado
 * @returns {{ tipo: string|null, numero: string|null }} Errores por campo
 */
export const validateTelefonoAlternativoConjunto = (tipoAlt, numAlt) => {
  const tipo = (tipoAlt || '').trim()
  const numero = (numAlt || '').trim()

  // Ambos vacíos: sin errores (opcionales)
  if (tipo === '' && numero === '') {
    return { tipo: null, numero: null }
  }

  // Tipo cargado y número vacío: falta completar el número
  if (tipo !== '' && numero === '') {
    return { tipo: null, numero: VALIDATION_MESSAGES.TELEFONO_INVALID }
  }

  // Número cargado (con o sin tipo): valida el formato del número en vivo y,
  // si falta el tipo, también señala ese campo
  if (numero !== '') {
    return {
      tipo: tipo === '' ? VALIDATION_MESSAGES.TIPO_TELEFONO_REQUIRED : null,
      numero: validatePhoneNumber(numero),
    }
  }

  return { tipo: null, numero: null }
}
